import {Observable}                    from 'rxjs';
import {filter, mapTo, withLatestFrom} from 'rxjs/operators';

import MediaEventType            from '../../../../Solutions/Shared/Constants/MediaEventType';
import IMediaEventsStreamPayload from '../../../../Solutions/Shared/Interfaces/IMediaEventsStreamPayload';
import Playback                  from '../Playback';

const createPauseStream = (
    mediaEvents$: Observable<IMediaEventsStreamPayload>,
    playbackStoreUpdate$: Observable<Playback>
): Observable<void> =>
    mediaEvents$
        .pipe(
            withLatestFrom(playbackStoreUpdate$),
            filter(([{type}, {isPaused, isLoading}]) => type === MediaEventType.PAUSE && !isPaused && !isLoading),
            mapTo(void 0)
        );

export default createPauseStream;